import React, { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Header from "../../../Header/Header";
import VICSMenu from "../../VICSMenu";
import DocMenu from "../../../DocMenu";
import GenPdf from "../../../GenPdf";
import history from "../../../Routes/history";
import { changeTitleName, changePdfFileName, changeIndication } from "../../../../redux/actions/emailAction";
import { changeVicValue, fetchCompaniesByDossierLot } from "../../../../redux/actions/vicActions";
import { newEntrepriseValue } from "../../../../redux/actions/entrepriseActions";
import { getQuestionsPage, updateQuestionsPage, getVicValues, genVicPDF, getVicPDF, getLotName, isVicSigned } from "../../Utils"
import YesNoDialog from "../../../YesNoDialog";
import { Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Save as SaveIcon, PictureAsPdf as PdfIcon, Visibility as VisibilityIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from "@material-ui/icons";
import "../../../../Styles/VIC/Page-2.scss";

const Page2 = ({ dispatch, vicValue, dossierValue, lotsValue, companies, entrepriseValue }) => {
  const [questionsLot, setQuestionsLot] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [file, setFile] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [indicationValue, setIndicationValue] = useState("");
  const [openSignatureDialog, setOpenSignatureDialog] = useState(false);
  const prevDossierValue = useRef(dossierValue);
  const prevLotsValue = useRef(lotsValue);
  const prevCompanies = useRef(companies);
  const prevEntrepriseValue = useRef(entrepriseValue);

  useEffect(() => {
    setDisableButton(true);
    const fetchQuestionsData = async () => {
      dispatch(changePdfFileName(""));
      const data = await getQuestionsPage(2, vicValue);

      if (data.length === 0) {
        setIndicationValue('');
      }
      setQuestionsLot(data)
    };

    fetchQuestionsData();
    setDisableButton(false);
  }, [vicValue]);

  useEffect(() => {
    setDisableButton(true);
    const fetchCompaniesData = async () => {
      if (prevDossierValue.current !== dossierValue || prevLotsValue.current !== lotsValue) {
        await dispatch(fetchCompaniesByDossierLot(dossierValue, lotsValue));

        prevDossierValue.current = dossierValue;
        prevLotsValue.current = lotsValue;
      }
    }

    fetchCompaniesData();
    setDisableButton(false);
  }, [dossierValue, lotsValue])

  useEffect(() => {
    setDisableButton(true);
    const fetchData = async () => {
      if (prevCompanies.current !== companies) {
        if (companies.length !== 0) {
          await dispatch(newEntrepriseValue(companies[0]))
          const result = await getVicValues(dossierValue, lotsValue, companies[0]);
          await dispatch(changeVicValue(result.id))
        } else {
          await dispatch(changeVicValue(""))
        };

        prevCompanies.current = companies;
      }

      if (prevEntrepriseValue.current !== entrepriseValue) {
        const result = await getVicValues(dossierValue, lotsValue, entrepriseValue);

        await dispatch(changeVicValue(result.id))

        prevEntrepriseValue.current = entrepriseValue
      }
    }

    fetchData();
    setDisableButton(false);
  }, [companies, entrepriseValue])

  useEffect(() => {
    setDisableButton(true);
    const getIndicationValue = async () => {
      const lotName = await getLotName(lotsValue);
      let conmapyName = '';

      try {
        const parsedValue = JSON.parse(entrepriseValue);
        conmapyName = parsedValue.nom || '';
      } catch (e) {
        conmapyName = entrepriseValue.nom || '';
      }

      setIndicationValue(`${lotName} - ${conmapyName}`);
    };

    getIndicationValue();
    setDisableButton(false);
  }, [entrepriseValue, lotsValue]);


  const handleValidClick = async () => {
    setDisableButton(true);
    await updateQuestionsPage(2, vicValue, questionsLot);
    setDisableButton(false);
  }

  const handleChange = (event, indexQstCat, indexQst) => {
    setDisableButton(true);
    const { name, value, checked } = event.target;
    let temp_state = [...questionsLot];
    let temp_element = { ...temp_state[indexQstCat] };
    temp_element.questions[indexQst][name] = name === "answer" ? value === "1" ? true : false : checked ? true : false;
    temp_state[indexQstCat] = temp_element;
    setQuestionsLot(temp_state);
    setDisableButton(false);
  };

  const generateVic = async () => {
    setDisableButton(true);
    setFile(null);
    let blob = await genVicPDF(vicValue);
    if (blob) {
      setFile(blob);
      setIsOpen(true);
    }
    setDisableButton(false);
  }

  const handleGenClick = async () => {
    setDisableButton(true);
    const signed = await isVicSigned(vicValue);

    if (!signed) {
      setDisableButton(false);
      setOpenSignatureDialog(true);
      return;
    }

    await generateVic();
  }

  const handleConfirmGenWithoutSignature = async () => {
    setOpenSignatureDialog(false);
    await generateVic();
  }

  const handleShowPdf = async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getVicPDF(vicValue, 'pdf');

    if (response.blob.size > 100) {
      setFile(response.blob);
      setIsOpen(true);

      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }

  const handleGetPdfFile = async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getVicPDF(vicValue, 'pdf');
    if (response.blob.size > 100) {
      setFile(response.blob);
      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }

  const handleGetWordFile = async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getVicPDF(vicValue, 'word');
    if (response.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setFile(response.blob);
    }
    setDisableButton(false);
  }

  const prevPage = () => {
    history.push("/vic/page-1");
  };

  const nextPage = () => {
    history.push("/vic/page-3");
  };

  const handleChangeTitleName = () => {
    dispatch(changeTitleName(`VIC`));
  };

  return (
    <div className="page2">
      <Header />
      <DocMenu
        file={file}
        getSourceFile={handleGetWordFile}
        getPDF={handleGetPdfFile}
        handleChangeTitleName={handleChangeTitleName}
        updateIndication={() => dispatch(changeIndication(indicationValue))}
      />
      <h1 className="title">Visite d'Inspection Commune (Page 2)</h1>
      <VICSMenu />
      <div className="data-page2">
        <table className="questions-table">
          <tbody>
            {questionsLot.map((questionCategory, indexQstCat) => (
              <Fragment key={indexQstCat}>
                <tr>
                  <td colSpan="2" className="double-border">{questionCategory.cat_question}</td>
                </tr>
                {questionCategory.questions.map((question, indexQst) => (
                  <tr key={question.question}>
                    <td className="col-1">{question.question}</td>
                    <td>
                      <span style={{ marginLeft: "10px" }}>
                        <label>Oui</label>
                        <input
                          type="checkbox"
                          name="answer"
                          value={1}
                          onChange={(event) => handleChange(event, indexQstCat, indexQst)}
                          checked={question.answer}
                        />
                        <label>Non</label>
                        <input
                          type="checkbox"
                          name="answer"
                          value={0}
                          onChange={(event) => handleChange(event, indexQstCat, indexQst)}
                          checked={!question.answer ? true : false}
                        />
                        <label>Observation</label>
                        <input
                          type="checkbox"
                          name="observation"
                          onChange={(event) => handleChange(event, indexQstCat, indexQst)}
                          checked={question.observation}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </Fragment>
            ))
            }
          </tbody>
        </table>
        <div className="buttons-container">
          <Button
            color="primary"
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={() => handleValidClick()}
            disabled={vicValue === "" || disableButton}
          >
            Enregistrer
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<PdfIcon />}
            onClick={() => handleGenClick()}
            disabled={vicValue === "" || disableButton}
          >
            Générer
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<VisibilityIcon />}
            onClick={() => handleShowPdf()}
            disabled={vicValue === "" || disableButton}
          >
            Afficher
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={prevPage}
            disabled={disableButton}
          >
            Précedent
          </Button>
          <Button
            color="primary"
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            onClick={nextPage}
            disabled={disableButton}
          >
            Suivant
          </Button>
          {disableButton && <CircularProgress className="spinner" color="inherit" />}
        </div>
      </div>
      <GenPdf
        file={file}
        isOpen={isOpen}
        closeDoc={() => setIsOpen(false)}
        scale={1}
      />
      <YesNoDialog
        isOpen={openSignatureDialog}
        title={"VIC NON SIGNÉE"}
        question={`Cette VIC n'est pas encore signée par l'entreprise. Voulez-vous quand même la générer ?`}
        handleYesClick={handleConfirmGenWithoutSignature}
        handleClose={() => setOpenSignatureDialog(false)}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  dossierValue: state.devis.dossierValue,
  vicValue: state.vic.vicValue,
  lotsValue: state.vic.lotsValue,
  companies: state.vic.companies,
  entrepriseValue: state.entreprise.entrepriseValue,
});

export default connect(mapStateToProps)(Page2);
